/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Card, Input, Table, Typography, Spin, message, Skeleton } from "antd";
import axios from "axios";


import { ReloadOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import constants from "../../../constants/constants";
import { formatIndianNumber, formatIndianCurrency } from "../../../utils";
import { DirectorDashboardService3 } from "../../../services/api/directorDashboardService3";

import "./style.scss";
import moment from "moment";

import { ReactComponent as HubInscanShipmentsIcon } from "../../../assests/images/DirectorDashboardSvg/HubInscanShipmentsIcon.svg";
import { ReactComponent as HubInscanBagIcon } from "../../../assests/images/DirectorDashboardSvg/HubInscanBag.svg";
import { ReactComponent as HubOutscanShipmentsIcon } from "../../../assests/images/DirectorDashboardSvg/HubOutScanShipment.svg";
import { ReactComponent as HubOutscanBagIcon } from "../../../assests/images/DirectorDashboardSvg/HubOutScanbag.svg";
import { ReactComponent as HubBagFinalizeIcon } from "../../../assests/images/DirectorDashboardSvg/HubBagFinalize.svg";

const { Title } = Typography;
const { ROLES } = constants;
const { ROLE_MD } = ROLES;

// KPI Icon SVG Paths


const DirectorDashboard3 = () => {
    const navigate = useNavigate();

    const [clientSearch, setClientSearch] = useState("");
    const [userRoles, setUserRoles] = useState([]);

    // Individual loading states for each section
    const [kpiDataLoading, setKpiDataLoading] = useState(false);

    // Separate loading states for each card
    const [businessDataPreviousDayLoading, setBusinessDataPreviousDayLoading] = useState(false);
    const [businessDataCurrentMonthLoading, setBusinessDataCurrentMonthLoading] = useState(false);
    const [shipmentCountsPreviousDayLoading, setShipmentCountsPreviousDayLoading] = useState(false);
    const [shipmentCountsCurrentMonthLoading, setShipmentCountsCurrentMonthLoading] = useState(false);
    const [deliveryDataPreviousDayLoading, setDeliveryDataPreviousDayLoading] = useState(false);
    const [deliveryDataCurrentMonthLoading, setDeliveryDataCurrentMonthLoading] = useState(false);

    // State for Today Hub Operations
    const [kpiData, setKpiData] = useState({
        todayHubInscanShipments: 0,
        todayHubInscanBags: 0,
        todayHubOutscanShipments: 0,
        todayHubOutscanBags: 0,
        todayHubFinalizeBags: 0,
    });

    // State for Business Data
    const [businessDataToday, setBusinessDataToday] = useState([]);
    const [businessDataRange, setBusinessDataRange] = useState([]);
    const [businessDataTodayTimeZone, setBusinessDataTodayTimeZone] = useState("");
    const [businessDataRangeTimeZone, setBusinessDataRangeTimeZone] = useState("");
    // Store raw dates from API response for passing to ZoneWiseView
    const [businessDataTodayDate, setBusinessDataTodayDate] = useState(""); // YYYY-MM-DD format
    const [businessDataRangeFromDate, setBusinessDataRangeFromDate] = useState(""); // YYYY-MM-DD format
    const [businessDataRangeToDate, setBusinessDataRangeToDate] = useState(""); // YYYY-MM-DD format

    // State for Shipment Counts
    const [shipmentCountsToday, setShipmentCountsToday] = useState([]);
    const [shipmentCountsRange, setShipmentCountsRange] = useState([]);
    const [shipmentCountsTodayTimeZone, setShipmentCountsTodayTimeZone] = useState("");
    const [shipmentCountsRangeTimeZone, setShipmentCountsRangeTimeZone] = useState("");

    // State for Delivery Data
    const [deliveryDataToday, setDeliveryDataToday] = useState([]);
    const [deliveryDataRange, setDeliveryDataRange] = useState([]);
    const [deliveryDataTodayTimeZone, setDeliveryDataTodayTimeZone] = useState("");
    const [deliveryDataTodayDate, setDeliveryDataTodayDate] = useState("");
    const [deliveryDataRangeTimeZone, setDeliveryDataRangeTimeZone] = useState("");
    const [deliveryDataRangeFromDate, setDeliveryDataRangeFromDate] = useState("");
    const [deliveryDataRangeToDate, setDeliveryDataRangeToDate] = useState("");

    useEffect(() => {
        const userinfo = JSON.parse(localStorage.getItem("userinfo") || "{}");
        setUserRoles(userinfo?.roles || []);
    }, []);

    // Helper function to parse and format numbers
    const parseAndFormat = useCallback((value) => {
        if (!value) return "0";
        const numValue = parseInt(value.toString().replace(/,/g, "").trim(), 10);
        return isNaN(numValue) ? "0" : formatIndianNumber(numValue);
    }, []);

    // Helper function to format label from figureSubtype
    const formatLabel = useCallback((subtype) => {
        // Convert camelCase to Title Case
        if (subtype === "fsc") return "FSC Charge";
        if (subtype === "totalBusiness") return "Total";
        if (subtype === "totalShipmentCount") return "Total";
        if (subtype === "totalDelivery") return "Total Shipments";
        if (subtype === "Piece") return "Piece Rate";
        // Capitalize first letter and add spaces before capital letters
        return subtype.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase()).trim();
    }, []);

    const buildBookingSummaryItems = useCallback((data, period) => {
        const prefix = period === "range" ? "range" : "today";
        const retailAmount = data.retail_total_charges_with_gst || 0;
        const creditAmount = data.credit_total_charges_with_gst || 0;
        const dpClientAmount = data.dp_client_total_charges_with_gst || 0;
        const pieceRateAmount = data.piece_rate_total_charges || 0;
        const totalAmount = retailAmount + creditAmount + dpClientAmount + pieceRateAmount;

        const businessItems = [
            { key: `${prefix}-business-1`, label: "Retail", value: formatIndianCurrency(retailAmount), rawValue: retailAmount },
            { key: `${prefix}-business-2`, label: "Credit", value: formatIndianCurrency(creditAmount), rawValue: creditAmount },
            { key: `${prefix}-business-3`, label: "DP Client", value: formatIndianCurrency(dpClientAmount), rawValue: dpClientAmount },
            { key: `${prefix}-business-4`, label: "Piece Rate", value: formatIndianCurrency(pieceRateAmount), rawValue: pieceRateAmount },
            { key: `${prefix}-business-5`, label: "Total", value: formatIndianCurrency(totalAmount), rawValue: totalAmount },
        ];

        const retailCount = data.retail_shipments || 0;
        const creditCount = data.credit_shipments || 0;
        const dpClientCount = data.dp_client_shipments || 0;
        const pieceRateCount = data.piece_rate_shipments || 0;
        const totalCount = retailCount + creditCount + dpClientCount + pieceRateCount;

        const shipmentItems = [
            { key: `${prefix}-shipment-1`, label: "Retail", value: parseAndFormat(retailCount), rawValue: retailCount },
            { key: `${prefix}-shipment-2`, label: "Credit", value: parseAndFormat(creditCount), rawValue: creditCount },
            { key: `${prefix}-shipment-3`, label: "DP Client", value: parseAndFormat(dpClientCount), rawValue: dpClientCount },
            { key: `${prefix}-shipment-4`, label: "Piece Rate", value: parseAndFormat(pieceRateCount), rawValue: pieceRateCount },
            { key: `${prefix}-shipment-5`, label: "Total", value: parseAndFormat(totalCount), rawValue: totalCount },
        ];

        return { businessItems, shipmentItems };
    }, [parseAndFormat]);

    const processBookingSummaryData = useCallback((responseData, period = "today") => {
        if (!responseData?.data?.data?.length) return;

        const data = responseData.data.data[0];
        const { businessItems, shipmentItems } = buildBookingSummaryItems(data, period);

        if (period === "range") {
            setBusinessDataRange(businessItems);
            setShipmentCountsRange(shipmentItems);
        } else {
            setBusinessDataToday(businessItems);
            setShipmentCountsToday(shipmentItems);
        }

        const appliedFrom = responseData.data.appliedFilters?.fromDate;
        const appliedTo = responseData.data.appliedFilters?.toDate;

        if (appliedFrom) {
            const fromMoment = moment(appliedFrom, "YYYY-MM-DD", true);
            const formattedFrom = fromMoment.isValid()
                ? fromMoment.format("DD/MM/YYYY")
                : appliedFrom;

            if (period === "range" && appliedTo) {
                const toMoment = moment(appliedTo, "YYYY-MM-DD", true);
                const formattedTo = toMoment.isValid()
                    ? toMoment.format("DD/MM/YYYY")
                    : appliedTo;
                const dateRange = `${formattedFrom} - ${formattedTo}`;
                setBusinessDataRangeTimeZone(dateRange);
                setShipmentCountsRangeTimeZone(dateRange);
                setBusinessDataRangeFromDate(appliedFrom);
                setBusinessDataRangeToDate(appliedTo);
            } else {
                setBusinessDataTodayTimeZone(formattedFrom);
                setShipmentCountsTodayTimeZone(formattedFrom);
                setBusinessDataTodayDate(appliedFrom);
            }
        }
    }, [buildBookingSummaryItems]);

    const buildDeliverySummaryItems = useCallback((data, period) => {
        const prefix = period === "range" ? "range" : "today";
        return [
            {
                key: `${prefix}-delivery-1`,
                label: "Delivery Percentage",
                value: String(Math.round(parseFloat(data.delivery_percentage) || 0)),
                rawValue: data.delivery_percentage || 0,
            },
            {
                key: `${prefix}-delivery-2`,
                label: "Delivered",
                value: parseAndFormat(data.delivered || 0),
                rawValue: data.delivered || 0,
            },
            {
                key: `${prefix}-delivery-3`,
                label: "Pending",
                value: parseAndFormat(data.pending || 0),
                rawValue: data.pending || 0,
            },
            {
                key: `${prefix}-delivery-4`,
                label: "Return Initiated",
                value: parseAndFormat(data.return_initiated || 0),
                rawValue: data.return_initiated || 0,
            },
            {
                key: `${prefix}-delivery-5`,
                label: "RTO Delivered",
                value: parseAndFormat(data.rto_delivered || 0),
                rawValue: data.rto_delivered || 0,
            },
            {
                key: `${prefix}-delivery-6`,
                label: "Undelivered",
                value: parseAndFormat((data.undelivered || 0) + (data.rto_undelivered || 0)),
                rawValue: (data.undelivered || 0) + (data.rto_undelivered || 0),
            },
            {
                key: `${prefix}-delivery-7`,
                label: "Total",
                value: parseAndFormat(data.total_shipments || 0),
                rawValue: data.total_shipments || 0,
            },
            {
                key: `${prefix}-delivery-8`,
                label: "Total DRS",
                value: parseAndFormat(data.total_drs || 0),
                rawValue: data.total_drs || 0,
            },
        ];
    }, [parseAndFormat]);

    const processDeliverySummaryData = useCallback((responseData, period = "today") => {
        if (!responseData?.data?.data?.length) return;

        const data = responseData.data.data[0];
        const deliveryItems = buildDeliverySummaryItems(data, period);

        if (period === "range") {
            setDeliveryDataRange(deliveryItems);
        } else {
            setDeliveryDataToday(deliveryItems);
        }

        const appliedFrom = responseData.data.appliedFilters?.fromDate;
        const appliedTo = responseData.data.appliedFilters?.toDate;

        if (appliedFrom) {
            const fromMoment = moment(appliedFrom, "YYYY-MM-DD", true);
            const formattedFrom = fromMoment.isValid()
                ? fromMoment.format("DD/MM/YYYY")
                : appliedFrom;

            if (period === "range" && appliedTo) {
                const toMoment = moment(appliedTo, "YYYY-MM-DD", true);
                const formattedTo = toMoment.isValid()
                    ? toMoment.format("DD/MM/YYYY")
                    : appliedTo;
                setDeliveryDataRangeTimeZone(`${formattedFrom} - ${formattedTo}`);
                setDeliveryDataRangeFromDate(appliedFrom);
                setDeliveryDataRangeToDate(appliedTo);
            } else {
                setDeliveryDataTodayTimeZone(formattedFrom);
                setDeliveryDataTodayDate(appliedFrom);
            }
        }
    }, [buildDeliverySummaryItems]);

    // Fetch all dashboard data - each API updates UI as soon as response arrives
    const fetchDashboardData = useCallback(async (signal) => {
        // Set loading states for each section
        setKpiDataLoading(true);
        setBusinessDataPreviousDayLoading(true);
        setBusinessDataCurrentMonthLoading(true);
        setShipmentCountsPreviousDayLoading(true);
        setShipmentCountsCurrentMonthLoading(true);
        setDeliveryDataPreviousDayLoading(true);
        setDeliveryDataCurrentMonthLoading(true);

        const options = { signal };
        const hubOpsDate = moment().subtract(1, "day").format("YYYY-MM-DD");
        const bookingDate = moment().subtract(1, "day").format("YYYY-MM-DD");
        const bookingRangeFrom = moment().startOf("month").format("YYYY-MM-DD");
        const bookingRangeTo = moment().subtract(1, "day").format("YYYY-MM-DD");
        const deliveryDate = moment().subtract(1, "day").format("YYYY-MM-DD");

        // Fetch HubOps data - update immediately when response arrives
        DirectorDashboardService3.getHubOpsData(hubOpsDate, hubOpsDate, options)
            .then((hubOpsResponse) => {
                if (hubOpsResponse?.data?.data && hubOpsResponse.data.data.length > 0) {
                    const data = hubOpsResponse.data.data[0];
                    setKpiData({
                        todayHubInscanShipments: data.hub_inscan_shipments || 0,
                        todayHubInscanBags: data.hub_inscan_bags || 0,
                        todayHubOutscanShipments: data.hub_outscan_shipments || 0,
                        todayHubOutscanBags: data.hub_outscan_bags || 0,
                        todayHubFinalizeBags: data.hub_bags_finalized || 0,
                    });
                }
            })
            .catch((error) => {
                if (axios.isCancel(error)) return;
                console.error("Error fetching HubOps data:", error);
            })
            .finally(() => {
                if (!signal?.aborted) setKpiDataLoading(false);
            });

        // Fetch Booking Summary - Previous Day (Business Data & Shipment Count)
        DirectorDashboardService3.getBookingSummary(bookingDate, bookingDate, options)
            .then((bookingResponse) => {
                processBookingSummaryData(bookingResponse, "today");
            })
            .catch((error) => {
                if (axios.isCancel(error)) return;
                console.error("Error fetching Booking Summary:", error);
            })
            .finally(() => {
                if (!signal?.aborted) {
                    setBusinessDataPreviousDayLoading(false);
                    setShipmentCountsPreviousDayLoading(false);
                }
            });

        // Fetch Delivery Summary - Previous Day
        DirectorDashboardService3.getDeliverySummary(deliveryDate, deliveryDate, options)
            .then((deliveryResponse) => {
                processDeliverySummaryData(deliveryResponse, "today");
            })
            .catch((error) => {
                if (axios.isCancel(error)) return;
                console.error("Error fetching Delivery Summary:", error);
            })
            .finally(() => {
                if (!signal?.aborted) setDeliveryDataPreviousDayLoading(false);
            });

        // Fetch Delivery Summary - Current Month range
        DirectorDashboardService3.getDeliverySummary(bookingRangeFrom, bookingRangeTo, options)
            .then((deliveryRangeResponse) => {
                processDeliverySummaryData(deliveryRangeResponse, "range");
            })
            .catch((error) => {
                if (axios.isCancel(error)) return;
                console.error("Error fetching Delivery Summary (range):", error);
            })
            .finally(() => {
                if (!signal?.aborted) setDeliveryDataCurrentMonthLoading(false);
            });

        // Fetch Booking Summary - Current Month range (Business Data & Shipment Count)
        DirectorDashboardService3.getBookingSummary(bookingRangeFrom, bookingRangeTo, options)
            .then((bookingRangeResponse) => {
                processBookingSummaryData(bookingRangeResponse, "range");
            })
            .catch((error) => {
                if (axios.isCancel(error)) return;
                console.error("Error fetching Booking Summary (range):", error);
            })
            .finally(() => {
                if (!signal?.aborted) {
                    setBusinessDataCurrentMonthLoading(false);
                    setShipmentCountsCurrentMonthLoading(false);
                }
            });
    }, [processBookingSummaryData, processDeliverySummaryData]);

    useEffect(() => {
        const controller = new AbortController();
        if (userRoles.includes(ROLE_MD)) {
            fetchDashboardData(controller.signal);
        }
        return () => controller.abort();
    }, [userRoles, fetchDashboardData]);


    // Refresh HubOps data (KPI cards) - First refresh cache, then fetch data
    const handleRefreshHubOps = useCallback(() => {
        setKpiDataLoading(true);
        const hubOpsDate = moment().subtract(1, "day").format("YYYY-MM-DD");

        DirectorDashboardService3.getHubOpsData(hubOpsDate, hubOpsDate)
            .then((hubOpsResponse) => {
                if (hubOpsResponse?.data?.data && hubOpsResponse.data.data.length > 0) {
                    const data = hubOpsResponse.data.data[0];
                    setKpiData({
                        todayHubInscanShipments: data.hub_inscan_shipments || 0,
                        todayHubInscanBags: data.hub_inscan_bags || 0,
                        todayHubOutscanShipments: data.hub_outscan_shipments || 0,
                        todayHubOutscanBags: data.hub_outscan_bags || 0,
                        todayHubFinalizeBags: data.hub_bags_finalized || 0,
                    });
                }
            })
            .catch((error) => {
                console.error("Error refreshing HubOps data:", error);
                message.error(error?.response?.data?.message || error?.message || "Failed to refresh data");
            })
            .finally(() => {
                setKpiDataLoading(false);
            });
    }, []);

    // Refresh Business Data - Previous Day
    const handleRefreshBusinessDataPreviousDay = useCallback(() => {
        setBusinessDataPreviousDayLoading(true);
        setShipmentCountsPreviousDayLoading(false);
        setDeliveryDataPreviousDayLoading(false);

        const bookingDate = businessDataTodayDate || moment().subtract(1, "day").format("YYYY-MM-DD");

        DirectorDashboardService3.getBookingSummary(bookingDate, bookingDate)
            .then((bookingResponse) => {
                processBookingSummaryData(bookingResponse, "today");
            })
            .catch((error) => {
                console.error("Error refreshing Business Data:", error);
                message.error(error?.response?.data?.message || error?.message || "Failed to refresh data");
            })
            .finally(() => {
                setBusinessDataPreviousDayLoading(false);
            });
    }, [processBookingSummaryData, businessDataTodayDate]);

    // Refresh Business Data - Current Month
    const handleRefreshBusinessDataCurrentMonth = useCallback(() => {
        setBusinessDataCurrentMonthLoading(true);
        setShipmentCountsCurrentMonthLoading(false);

        const rangeFrom = businessDataRangeFromDate || moment().startOf("month").format("YYYY-MM-DD");
        const rangeTo = businessDataRangeToDate || moment().subtract(1, "day").format("YYYY-MM-DD");

        DirectorDashboardService3.getBookingSummary(rangeFrom, rangeTo)
            .then((bookingResponse) => {
                processBookingSummaryData(bookingResponse, "range");
            })
            .catch((error) => {
                console.error("Error refreshing Business Data (range):", error);
                message.error(error?.response?.data?.message || error?.message || "Failed to refresh data");
            })
            .finally(() => {
                setBusinessDataCurrentMonthLoading(false);
            });
    }, [processBookingSummaryData, businessDataRangeFromDate, businessDataRangeToDate]);

    // Refresh Shipment Counts - Previous Day
    const handleRefreshShipmentCountsPreviousDay = useCallback(() => {
        setShipmentCountsPreviousDayLoading(true);
        setBusinessDataPreviousDayLoading(false);
        setDeliveryDataPreviousDayLoading(false);

        const bookingDate = businessDataTodayDate || moment().subtract(1, "day").format("YYYY-MM-DD");

        DirectorDashboardService3.getBookingSummary(bookingDate, bookingDate)
            .then((bookingResponse) => {
                processBookingSummaryData(bookingResponse, "today");
            })
            .catch((error) => {
                console.error("Error refreshing Shipment Counts:", error);
                message.error(error?.response?.data?.message || error?.message || "Failed to refresh data");
            })
            .finally(() => {
                setShipmentCountsPreviousDayLoading(false);
            });
    }, [processBookingSummaryData, businessDataTodayDate]);

    // Refresh Shipment Counts - Current Month
    const handleRefreshShipmentCountsCurrentMonth = useCallback(() => {
        setShipmentCountsCurrentMonthLoading(true);
        setBusinessDataCurrentMonthLoading(false);

        const rangeFrom = businessDataRangeFromDate || moment().startOf("month").format("YYYY-MM-DD");
        const rangeTo = businessDataRangeToDate || moment().subtract(1, "day").format("YYYY-MM-DD");

        DirectorDashboardService3.getBookingSummary(rangeFrom, rangeTo)
            .then((bookingResponse) => {
                processBookingSummaryData(bookingResponse, "range");
            })
            .catch((error) => {
                console.error("Error refreshing Shipment Counts (range):", error);
                message.error(error?.response?.data?.message || error?.message || "Failed to refresh data");
            })
            .finally(() => {
                setShipmentCountsCurrentMonthLoading(false);
            });
    }, [processBookingSummaryData, businessDataRangeFromDate, businessDataRangeToDate]);

    // Refresh Delivery Data - Previous Day
    const handleRefreshDeliveryDataPreviousDay = useCallback(() => {
        setDeliveryDataPreviousDayLoading(true);
        const deliveryDate = deliveryDataTodayDate || moment().subtract(1, "day").format("YYYY-MM-DD");

        DirectorDashboardService3.getDeliverySummary(deliveryDate, deliveryDate)
            .then((deliveryResponse) => {
                processDeliverySummaryData(deliveryResponse, "today");
            })
            .catch((error) => {
                console.error("Error refreshing Delivery Data:", error);
                message.error(error?.response?.data?.message || error?.message || "Failed to refresh data");
            })
            .finally(() => {
                setDeliveryDataPreviousDayLoading(false);
            });
    }, [processDeliverySummaryData, deliveryDataTodayDate]);

    const handleRefreshDeliveryDataCurrentMonth = useCallback(() => {
        setDeliveryDataCurrentMonthLoading(true);
        const rangeFrom = deliveryDataRangeFromDate || moment().startOf("month").format("YYYY-MM-DD");
        const rangeTo = deliveryDataRangeToDate || moment().subtract(1, "day").format("YYYY-MM-DD");

        DirectorDashboardService3.getDeliverySummary(rangeFrom, rangeTo)
            .then((deliveryResponse) => {
                processDeliverySummaryData(deliveryResponse, "range");
            })
            .catch((error) => {
                console.error("Error refreshing Delivery Data (range):", error);
                message.error(error?.response?.data?.message || error?.message || "Failed to refresh data");
            })
            .finally(() => {
                setDeliveryDataCurrentMonthLoading(false);
            });
    }, [processDeliverySummaryData, deliveryDataRangeFromDate, deliveryDataRangeToDate]);

    // Refresh all data (for initial load)
    const handleRefresh = () => {
        fetchDashboardData();
    };

    const handleViewZoneWise = (e, type = "today", reportType = "Piece Rate", reportCategory = "Business Data", businessType = null) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        // Use dates directly from API response (stored in state)
        let dateToPass, endDateToPass;
        if (type === "today") {
            if (reportCategory === "Delivery Data" && deliveryDataTodayDate) {
                dateToPass = deliveryDataTodayDate;
                endDateToPass = deliveryDataTodayDate;
            } else if (businessDataTodayDate) {
                dateToPass = businessDataTodayDate;
            } else {
                dateToPass = moment().subtract(1, "day").format("YYYY-MM-DD");
            }
        } else if (reportCategory === "Delivery Data" && deliveryDataRangeFromDate && deliveryDataRangeToDate) {
            dateToPass = deliveryDataRangeFromDate;
            endDateToPass = deliveryDataRangeToDate;
        } else if (businessDataRangeFromDate && businessDataRangeToDate) {
            dateToPass = businessDataRangeFromDate;
            endDateToPass = businessDataRangeToDate;
        } else {
            dateToPass = moment().startOf("month").format("YYYY-MM-DD");
            endDateToPass = moment().subtract(1, "day").format("YYYY-MM-DD");
        }

        const routeMap = {
            "Business Data": "/zone-wise-business-data2",
            "Shipment Counts": "/zone-wise-shipment-counts2",
            "Delivery Data": "/zone-wise-delivery-data2",

        };
        navigate(routeMap[reportCategory] || "/zone-wise-business-data2", {
            state: {
                type,
                reportType,
                reportCategory,
                date: dateToPass, // Start date in "YYYY-MM-DD" format from API response
                endDate: type === "range" || reportCategory === "Delivery Data" ? endDateToPass : undefined,
                businessType,
            },
        });
    };

    const isDeliveryLabelClickable = (label) => label !== "Total" && label !== "Total DRS";

    // Handle click on table row (Retail, Credit, Delivered, etc.)
    const handleTableRowClick = (record, reportCategory, dataType) => {
        // Don"t navigate if it"s the Total row
        if (record.label === "Total") {
            return;
        }

        // Map label to business type name - use label directly as businessType
        const businessType = record.label;

        // Use dates directly from API response (stored in state)
        let dateToPass, endDateToPass;

        if (dataType === "today") {
            if (reportCategory === "Delivery Data" && deliveryDataTodayDate) {
                dateToPass = deliveryDataTodayDate;
                endDateToPass = deliveryDataTodayDate;
            } else if (businessDataTodayDate) {
                dateToPass = businessDataTodayDate;
            } else {
                dateToPass = moment().subtract(1, "day").format("YYYY-MM-DD");
            }
        } else if (reportCategory === "Delivery Data" && deliveryDataRangeFromDate && deliveryDataRangeToDate) {
            dateToPass = deliveryDataRangeFromDate;
            endDateToPass = deliveryDataRangeToDate;
        } else if (businessDataRangeFromDate && businessDataRangeToDate) {
            dateToPass = businessDataRangeFromDate;
            endDateToPass = businessDataRangeToDate;
        } else {
            dateToPass = moment().startOf("month").format("YYYY-MM-DD");
            endDateToPass = moment().subtract(1, "day").format("YYYY-MM-DD");
        }

        navigate("/zone-list2", {
            state: {
                type: dataType,
                reportType: "Piece Rate",
                reportCategory: reportCategory,
                date: dateToPass,
                endDate: reportCategory === "Delivery Data" || dataType === "range" ? endDateToPass : undefined,
                businessType: businessType,
            },
        });
    };

    // Check if user has ROLE_MD access
    if (!userRoles.includes(ROLE_MD)) {
        return (
            <div className="director-dashboard-access-denied">
                <Card>
                    <Title level={4}>Access Denied</Title>
                    <p>You do not have permission to access this dashboard.</p>
                </Card>
            </div>
        );
    }

    // Use TimeZone from API if available, otherwise use current date
    const todayDate = businessDataTodayTimeZone || moment().format("DD/MM/YYYY");
    const dateRange = businessDataRangeTimeZone || (() => {
        const rangeStartDate = moment().startOf("month").format("DD/MM/YYYY");
        const rangeEndDate = moment().format("DD/MM/YYYY");
        return `${rangeStartDate} - ${rangeEndDate}`;
    })();

    // Use TimeZone from API for Shipment Counts if available
    const shipmentTodayDate = shipmentCountsTodayTimeZone || todayDate;
    const shipmentDateRange = shipmentCountsRangeTimeZone || dateRange;
    const deliveryTodayDate = deliveryDataTodayTimeZone || todayDate;
    const deliveryDateRange = deliveryDataRangeTimeZone || dateRange;

    // Table columns for data tables
    const dataTableColumns = [
        {
            title: "",
            dataIndex: "label",
            key: "label",
            width: "60%",
        },
        {
            title: "",
            dataIndex: "value",
            key: "value",
            width: "40%",
            align: "right",
        },
    ];

    // Helper function to create columns with clickable label for Previous Day tables
    const getClickableLabelColumns = (reportCategory, dataType) => {
        // Get data array based on reportCategory and dataType
        let dataArray = [];
        if (dataType === "today") {
            if (reportCategory === "Business Data") {
                dataArray = businessDataToday;
            } else if (reportCategory === "Shipment Counts") {
                dataArray = shipmentCountsToday;
            } else if (reportCategory === "Delivery Data") {
                dataArray = deliveryDataToday;
            }
        } else {
            // For range type
            if (reportCategory === "Business Data") {
                dataArray = businessDataRange;
            } else if (reportCategory === "Shipment Counts") {
                dataArray = shipmentCountsRange;
            } else if (reportCategory === "Delivery Data") {
                dataArray = deliveryDataRange;
            }
        }

        // Extract all labels from the data array, excluding "Total" and "Total Shipments"
        const allowedLabels = dataArray
            .map(item => item.label)
            .filter(label => label !== "total" && label !== "Delivery Percentage");

        return [
            {
                title: "",
                dataIndex: "label",
                key: "label",
                width: "60%",
                render: (label, record) => {
                    const isClickable = allowedLabels.includes(label);

                    // Make "totalDelivery" (second-to-last) bold - row highlighting is handled by rowClassName
                    if (label === "Total") {
                        return <strong>{label}</strong>;
                    }

                    // Make "Total DRS" (last) bold and non-clickable
                    // if (label === "Total DRS") {
                    //     return <strong>{label}</strong>;
                    // }

                    if (record.label === "Total" || !isClickable) {
                        return <span>{label}</span>;
                    }

                    return (
                        <span
                            onClick={() => handleTableRowClick(record, reportCategory, dataType)}
                            style={{
                                cursor: "pointer",
                                color: "#1890ff",
                                textDecoration: "none",
                            }}
                        >
                            {label}
                        </span>
                    );
                },
            },
            {
                title: "",
                dataIndex: "value",
                key: "value",
                width: "40%",
                align: "right",
            },
        ];
    };

    const handleViewHubOpsZoneWise = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        const hubOpsDate = moment().subtract(1, "day").format("YYYY-MM-DD");
        navigate("/hub-ops-zone-wise2", {
            state: { date: hubOpsDate },
        });
    };

    const hubOpsSummaryDate = moment().subtract(1, "day").format("DD/MM/YYYY");

    return (
        <div className="director-dashboard">
            <div className="director-dashboard-content">
                {/* KPI Cards Section */}
                <div className="kpi-section-header data-table-header">
                    <div className="header-title-group">
                        <span className="box-title">Hub Operations Summary</span>
                        <span className="box-subtitle">{hubOpsSummaryDate}</span>
                    </div>
                    <button
                        type="button"
                        onClick={handleViewHubOpsZoneWise}
                        className="view-zone-btn"
                    >
                        View Zone Wise →
                    </button>
                </div>
                <div className="kpi-cards-row">
                    <div className="kpi-card-wrapper">
                        <Card className="kpi-card kpi-card-purple">
                            {kpiDataLoading ? (
                                <div className="kpi-card-content" style={{ padding: "12px 16px" }}>
                                    <Skeleton.Avatar active size={40} shape="circle" style={{ marginRight: 16 }} />
                                    <div style={{ flex: 1 }}>
                                        <Skeleton.Input active size="small" style={{ width: "80%", marginBottom: 8, height: 16 }} />
                                        <Skeleton.Input active size="large" style={{ width: "50%", height: 24 }} />
                                    </div>
                                </div>
                            ) : (
                                <div className="kpi-card-content">
                                    <div className="kpi-card-icon">
                                        <HubInscanShipmentsIcon />
                                    </div>
                                    <div className="kpi-card-info">
                                        <div className="kpi-card-title">Hub Inscan Shipments</div>
                                        <div className="kpi-card-value">{formatIndianNumber(kpiData.todayHubInscanShipments)}</div>
                                    </div>
                                </div>
                            )}
                        </Card>

                    </div>
                    <div className="kpi-card-wrapper">
                        <Card className="kpi-card kpi-card-purple">
                            {kpiDataLoading ? (
                                <div className="kpi-card-content" style={{ padding: "12px 16px" }}>
                                    <Skeleton.Avatar active size={40} shape="circle" style={{ marginRight: 16 }} />
                                    <div style={{ flex: 1 }}>
                                        <Skeleton.Input active size="small" style={{ width: "80%", marginBottom: 8, height: 16 }} />
                                        <Skeleton.Input active size="large" style={{ width: "50%", height: 24 }} />
                                    </div>
                                </div>
                            ) : (
                                <div className="kpi-card-content">
                                    <div className="kpi-card-icon">
                                        <HubInscanBagIcon />
                                    </div>
                                    <div className="kpi-card-info">
                                        <div className="kpi-card-title">Hub Inscan Bags</div>
                                        <div className="kpi-card-value">{formatIndianNumber(kpiData.todayHubInscanBags)}</div>
                                    </div>
                                </div>
                            )}
                        </Card>

                    </div>
                    <div className="kpi-card-wrapper">
                        <Card className="kpi-card kpi-card-purple">
                            {kpiDataLoading ? (
                                <div className="kpi-card-content" style={{ padding: "12px 16px" }}>
                                    <Skeleton.Avatar active size={40} shape="circle" style={{ marginRight: 16 }} />
                                    <div style={{ flex: 1 }}>
                                        <Skeleton.Input active size="small" style={{ width: "80%", marginBottom: 8, height: 16 }} />
                                        <Skeleton.Input active size="large" style={{ width: "50%", height: 24 }} />
                                    </div>
                                </div>
                            ) : (
                                <div className="kpi-card-content">
                                    <div className="kpi-card-icon">
                                        <HubOutscanShipmentsIcon />
                                    </div>
                                    <div className="kpi-card-info">
                                        <div className="kpi-card-title">Hub Outscan Shipments</div>
                                        <div className="kpi-card-value">{formatIndianNumber(kpiData.todayHubOutscanShipments)}</div>
                                    </div>
                                </div>
                            )}
                        </Card>

                    </div>
                    <div className="kpi-card-wrapper">
                        <Card className="kpi-card kpi-card-purple">
                            {kpiDataLoading ? (
                                <div className="kpi-card-content" style={{ padding: "12px 16px" }}>
                                    <Skeleton.Avatar active size={40} shape="circle" style={{ marginRight: 16 }} />
                                    <div style={{ flex: 1 }}>
                                        <Skeleton.Input active size="small" style={{ width: "80%", marginBottom: 8, height: 16 }} />
                                        <Skeleton.Input active size="large" style={{ width: "50%", height: 24 }} />
                                    </div>
                                </div>
                            ) : (
                                <div className="kpi-card-content">
                                    <div className="kpi-card-icon">
                                        <HubOutscanBagIcon />
                                    </div>
                                    <div className="kpi-card-info">
                                        <div className="kpi-card-title">Hub Outscan Bags</div>
                                        <div className="kpi-card-value">{formatIndianNumber(kpiData.todayHubOutscanBags)}</div>
                                    </div>
                                </div>
                            )}
                        </Card>

                    </div>
                    <div className="kpi-card-wrapper">
                        <Card className="kpi-card kpi-card-purple">
                            {kpiDataLoading ? (
                                <div className="kpi-card-content" style={{ padding: "12px 16px" }}>
                                    <Skeleton.Avatar active size={40} shape="circle" style={{ marginRight: 16 }} />
                                    <div style={{ flex: 1 }}>
                                        <Skeleton.Input active size="small" style={{ width: "80%", marginBottom: 8, height: 16 }} />
                                        <Skeleton.Input active size="large" style={{ width: "50%", height: 24 }} />
                                    </div>
                                </div>
                            ) : (
                                <div className="kpi-card-content">
                                    <div className="kpi-card-icon">
                                        <HubBagFinalizeIcon />
                                    </div>
                                    <div className="kpi-card-info">
                                        <div className="kpi-card-title">Hub Bag Finalized</div>
                                        <div className="kpi-card-value">{formatIndianNumber(kpiData.todayHubFinalizeBags)}</div>
                                    </div>
                                </div>
                            )}
                        </Card>

                    </div>
                </div>


                {/* Data Tables Section */}
                <Row gutter={[24, 24]} className="data-tables-row">
                    {/* Business Data Column */}
                    <Col xs={24} lg={8}>
                        {/* Business Data - Today */}
                        <Card
                            className="data-overview-card"
                            title={
                                <div className="data-table-header">
                                    <div className="header-title-group">
                                        <span className="box-title">Business Data</span>
                                        <span className="box-subtitle">{todayDate}</span>
                                    </div>
                                    <button onClick={(e) => handleViewZoneWise(e, "today", "Piece Rate", "Business Data")} className="view-zone-btn">
                                        View Zone Wise →
                                    </button>
                                </div>
                            }
                        >
                            {businessDataPreviousDayLoading ? (
                                <Skeleton active paragraph={{ rows: 5 }} />
                            ) : (
                                <div className="data-grid">
                                    {businessDataToday.map((item) => (
                                        <div
                                            key={item.key}
                                            className={`data-grid-item ${item.label === "Total" ? "total-item" : "clickable"}`}
                                            onClick={() => item.label !== "Total" && handleTableRowClick(item, "Business Data", "today")}
                                            style={{ cursor: item.label !== "Total" ? "pointer" : "default" }}
                                        >
                                            <div className="item-label">{item.label}</div>
                                            <div className={`item-value ${item.label === "Total" ? "highlight" : ""}`}>{item.value}</div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Card>


                        {/* Business Data - Range */}
                        <Card
                            className="data-overview-card"
                            title={
                                <div className="data-table-header">
                                    <div className="header-title-group">
                                        <span className="box-title">Business Data</span>
                                        <span className="box-subtitle">{dateRange}</span>
                                    </div>
                                    <button onClick={(e) => handleViewZoneWise(e, "range", "Piece Rate", "Business Data")} className="view-zone-btn">
                                        View Zone Wise →
                                    </button>
                                </div>
                            }
                        >
                            {businessDataCurrentMonthLoading ? (
                                <Skeleton active paragraph={{ rows: 5 }} />
                            ) : (
                                <div className="data-grid">
                                    {businessDataRange.map((item) => (
                                        <div
                                            key={item.key}
                                            className={`data-grid-item ${item.label === "Total" ? "total-item" : "clickable"}`}
                                            onClick={() => item.label !== "Total" && handleTableRowClick(item, "Business Data", "range")}
                                            style={{ cursor: item.label !== "Total" ? "pointer" : "default" }}
                                        >
                                            <div className="item-label">{item.label}</div>
                                            <div className={`item-value ${item.label === "Total" ? "highlight" : ""}`}>{item.value}</div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Card>

                    </Col>

                    {/* Shipment Counts Column */}
                    <Col xs={24} lg={8}>
                        {/* Shipment Counts - Today */}
                        <Card
                            className="data-overview-card"
                            title={
                                <div className="data-table-header">
                                    <div className="header-title-group">
                                        <span className="box-title">Shipment Count</span>
                                        <span className="box-subtitle">{shipmentTodayDate}</span>
                                    </div>
                                    <button onClick={(e) => handleViewZoneWise(e, "today", "Piece Rate", "Shipment Counts")} className="view-zone-btn">
                                        View Zone Wise →
                                    </button>
                                </div>
                            }
                        >
                            {shipmentCountsPreviousDayLoading ? (
                                <Skeleton active paragraph={{ rows: 5 }} />
                            ) : (
                                <div className="data-grid">
                                    {shipmentCountsToday.map((item) => (
                                        <div
                                            key={item.key}
                                            className={`data-grid-item ${item.label === "Total" ? "total-item" : "clickable"}`}
                                            onClick={() => item.label !== "Total" && handleTableRowClick(item, "Shipment Counts", "today")}
                                            style={{ cursor: item.label !== "Total" ? "pointer" : "default" }}
                                        >
                                            <div className="item-label">{item.label}</div>
                                            <div className={`item-value ${item.label === "Total" ? "highlight" : ""}`}>{item.value}</div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Card>


                        {/* Shipment Counts - Range */}
                        <Card
                            className="data-overview-card"
                            title={
                                <div className="data-table-header">
                                    <div className="header-title-group">
                                        <span className="box-title">Shipment Count</span>
                                        <span className="box-subtitle">{shipmentDateRange}</span>
                                    </div>
                                    <button onClick={(e) => handleViewZoneWise(e, "range", "Piece Rate", "Shipment Counts")} className="view-zone-btn">
                                        View Zone Wise →
                                    </button>
                                </div>
                            }
                        >
                            {shipmentCountsCurrentMonthLoading ? (
                                <Skeleton active paragraph={{ rows: 5 }} />
                            ) : (
                                <div className="data-grid">
                                    {shipmentCountsRange.map((item) => (
                                        <div
                                            key={item.key}
                                            className={`data-grid-item ${item.label === "Total" ? "total-item" : "clickable"}`}
                                            onClick={() => item.label !== "Total" && handleTableRowClick(item, "Shipment Counts", "range")}
                                            style={{ cursor: item.label !== "Total" ? "pointer" : "default" }}
                                        >
                                            <div className="item-label">{item.label}</div>
                                            <div className={`item-value ${item.label === "Total" ? "highlight" : ""}`}>{item.value}</div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Card>

                    </Col>

                    {/* Delivery Data Column */}
                    <Col xs={24} lg={8}>
                        {/* Delivery Data - Today */}
                        <Card
                            className="data-overview-card"
                            title={
                                <div className="data-table-header">
                                    <div className="header-title-group">
                                        <span className="box-title">Delivery Data</span>
                                        <span className="box-subtitle">{deliveryTodayDate}</span>
                                    </div>
                                    <button onClick={(e) => handleViewZoneWise(e, "today", "Piece Rate", "Delivery Data")} className="view-zone-btn">
                                        View Zone Wise →
                                    </button>
                                </div>
                            }
                        >
                            {deliveryDataPreviousDayLoading ? (
                                <Skeleton active paragraph={{ rows: 5 }} />
                            ) : (
                                <div className="delivery-list">
                                    {deliveryDataToday.map((item) => (
                                        <div
                                            key={item.key}
                                            className={`delivery-item ${isDeliveryLabelClickable(item.label) ? "clickable" : ""}`}
                                            onClick={() => isDeliveryLabelClickable(item.label) && handleTableRowClick(item, "Delivery Data", "today")}
                                            style={{ cursor: isDeliveryLabelClickable(item.label) ? "pointer" : "default" }}
                                        >
                                            <div className="d-label">{item.label}</div>
                                            <div className="d-value">{item.value}</div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Card>

                        {/* Delivery Data - Range */}
                        <Card
                            className="data-overview-card"
                            title={
                                <div className="data-table-header">
                                    <div className="header-title-group">
                                        <span className="box-title">Delivery Data</span>
                                        <span className="box-subtitle">{deliveryDateRange}</span>
                                    </div>
                                    <button onClick={(e) => handleViewZoneWise(e, "range", "Piece Rate", "Delivery Data")} className="view-zone-btn">
                                        View Zone Wise →
                                    </button>
                                </div>
                            }
                        >
                            {deliveryDataCurrentMonthLoading ? (
                                <Skeleton active paragraph={{ rows: 5 }} />
                            ) : (
                                <div className="delivery-list">
                                    {deliveryDataRange.map((item) => (
                                        <div
                                            key={item.key}
                                            className={`delivery-item ${isDeliveryLabelClickable(item.label) ? "clickable" : ""}`}
                                            onClick={() => isDeliveryLabelClickable(item.label) && handleTableRowClick(item, "Delivery Data", "range")}
                                            style={{ cursor: isDeliveryLabelClickable(item.label) ? "pointer" : "default" }}
                                        >
                                            <div className="d-label">{item.label}</div>
                                            <div className="d-value">{item.value}</div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Card>

                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default DirectorDashboard3;
